const dataLayerPush = (eventData) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
};
  
export default dataLayerPush;